module.exports = __webpack_public_path__ + "static/media/resources.c4f842ae.md";